import actions, { registerActions } from './actionRegistry';
import services, { registerServices } from './serviceRegistry';

export { actions, services };

const defaults = {
    actions,
    registerActions,
    services,
    registerServices,
};

export default defaults;
